import { TutorialStep } from 'src/replicant/tutorial/tutorial.ruleset';
import { showTutorial } from '../tutorial.util';
import { TutorialEvent } from '../TutorialController';
import OrdinaryTutorial from './OrdinaryTutorial';

export class DuoInviteTutorial extends OrdinaryTutorial {
  public readonly step: TutorialStep = 'duoInvite';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    if (event !== 'duoInviteSequenceStarted') return false;

    await showTutorial('duoInvite', {
      $stepIndex: 14,
      $stepName: 'duo_invite',
    });

    return true;
  }
}
